import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { OFACScreeningStatusEnum } from 'anchor-kyb-service/types';
export class LatestOFACSanctionStatusModel {
    requiresInquiry() {
        return !this.dto.status || ![
            OFACScreeningStatusEnum.Cleared,
            OFACScreeningStatusEnum.AwaitingDecision
        ].includes(this.dto.status);
    }
    constructor(dto){
        _define_property(this, "dto", void 0);
        this.dto = dto;
    }
}
